module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-redis-02-m-jp.f482809a92867f85c49b2f1ddcd22440.png";